import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import CommonCard from "../../common/components/CommonCard";
import { Check, WatchLaterOutlined } from "@mui/icons-material";

const Tasks = ({
    stat
}) => {
    return (
        <Grid container spacing={1} mb={2}>
            <Grid item md={4}>
                <CommonCard
                    paddingBottom="0px"
                    borderRadius={1}
                    marginTop={1}
                    content={
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Box>
                                <Typography fontWeight={600}>
                                    {stat?.total_completed_sessions || 0}
                                </Typography>
                                <Typography color="background.dark">Session Completed</Typography>
                            </Box>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                background: '#EFF6FF',
                                width: 40,
                                height: 40,
                                position: 'relative'
                            }}>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '50%',
                                    border: '2px solid #155DFC',
                                    width: 20,
                                    height: 20
                                }}>
                                    <Check sx={{ color: '#155DFC', fontSize: 12 }} />
                                </Box>
                            </Box>
                        </Box>
                    }
                />
            </Grid>
            <Grid item md={4}>
                <CommonCard
                    paddingBottom="0px"
                    borderRadius={1}
                    marginTop={1}
                    content={
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Box>
                                <Typography fontWeight={600}>
                                    {stat?.total_completed_task || 0}
                                </Typography>
                                <Typography color="background.dark">Task Completed</Typography>
                            </Box>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                background: '#DCFCE7',
                                width: 40,
                                height: 40,
                                position: 'relative'
                            }}>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '50%',
                                    border: '2px solid #00A63E',
                                    width: 20,
                                    height: 20
                                }}>
                                    <Check sx={{ color: '#00A63E', fontSize: 12 }} />
                                </Box>
                            </Box>
                        </Box>
                    }
                />
            </Grid>
            <Grid item md={4}>
                <CommonCard
                    paddingBottom="0px"
                    borderRadius={1}
                    marginTop={1}
                    content={
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Box>
                                <Typography fontWeight={600}>
                                    {stat?.total_pending_task || 0}
                                </Typography>
                                <Typography color="background.dark">Task Pending</Typography>
                            </Box>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                background: '#FFEDD4',
                                width: 40,
                                height: 40,
                                position: 'relative'
                            }}>
                                <WatchLaterOutlined sx={{ color: '#F54900', fontSize: 22 }} />
                            </Box>
                        </Box>
                    }
                />
            </Grid>
        </Grid>
    )
}

export default Tasks;